import { Component, computed } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'layout-debug',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed bottom-4 left-50 z-50 rounded-lg bg-black/80 p-3 text-xs text-white shadow-lg backdrop-blur-sm">
      <div class="mb-2 font-semibold text-yellow-400">Layout Debug</div>

      <div class="space-y-1">
        <div class="flex justify-between gap-4">
          <span>Desktop:</span>
          <span [class]="layoutService.isDesktop() ? 'text-green-400' : 'text-red-400'">
            {{ layoutService.isDesktop() ? 'YES' : 'NO' }}
          </span>
        </div>

        <div class="flex justify-between gap-4">
          <span>Mobile:</span>
          <span [class]="layoutService.isMobile() ? 'text-green-400' : 'text-red-400'">
            {{ layoutService.isMobile() ? 'YES' : 'NO' }}
          </span>
        </div>

        <div class="flex justify-between gap-4">
          <span>Menu Collapsed:</span>
          <span [class]="layoutService.isMenuCollapsed() ? 'text-orange-400' : 'text-green-400'">
            {{ layoutService.isMenuCollapsed() ? 'YES' : 'NO' }}
          </span>
        </div>

        <div class="flex justify-between gap-4">
          <span>Mobile Menu Open:</span>
          <span [class]="layoutService.isMobileMenuOpen() ? 'text-green-400' : 'text-red-400'">
            {{ layoutService.isMobileMenuOpen() ? 'YES' : 'NO' }}
          </span>
        </div>

        <div class="flex justify-between gap-4">
          <span>Dark Theme:</span>
          <span [class]="layoutService.isDarkTheme() ? 'text-purple-400' : 'text-yellow-400'">
            {{ layoutService.isDarkTheme() ? 'DARK' : 'LIGHT' }}
          </span>
        </div>

        <div class="flex justify-between gap-4">
          <span>Fullscreen:</span>
          <span [class]="layoutService.isFullscreen() ? 'text-blue-400' : 'text-gray-400'">
            {{ layoutService.isFullscreen() ? 'YES' : 'NO' }}
          </span>
        </div>

        <div class="mt-2 border-t border-gray-600 pt-2">
          <div class="mb-1 text-xs text-gray-400">Container Classes:</div>
          <div class="text-xs">
            @for (class of getActiveClasses(); track class) {
              <div class="text-cyan-400">• {{ class }}</div>
            }
          </div>
        </div>
      </div>
    </div>
  `
})
export class LayoutDebugComponent {

  constructor(public layoutService: LayoutService) {

  }

  getActiveClasses(): string[] {
    const classes = this.layoutService.containerClasses();
    return Object.entries(classes)
      .filter(([key, value]) => value)
      .map(([key]) => key);
  }
}
